import * as yup from "yup";

// Schema for admin password reset
export const adminPasswordResetSchema = yup.object({
  currentPassword: yup
    .string()
    .required("Le mot de passe actuel est requis")
    .min(1, "Le mot de passe actuel ne peut pas être vide"),

  newPassword: yup
    .string()
    .required("Le nouveau mot de passe est requis")
    .min(8, "Le nouveau mot de passe doit contenir au moins 8 caractères")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      "Le nouveau mot de passe doit contenir au moins une minuscule, une majuscule et un chiffre",
    )
    .test(
      "different-from-current",
      "Le nouveau mot de passe doit être différent du mot de passe actuel",
      function (value) {
        const { currentPassword } = this.parent;
        return value !== currentPassword;
      },
    ),

  confirmPassword: yup
    .string()
    .required("La confirmation du mot de passe est requise")
    .oneOf([yup.ref("newPassword")], "Les mots de passe ne correspondent pas"),
});

// Schema for admin creation
export const adminCreateSchema = yup.object({
  firstName: yup
    .string()
    .required("Le prénom est requis")
    .min(2, "Le prénom doit contenir au moins 2 caractères")
    .max(50, "Le prénom ne peut pas dépasser 50 caractères"),

  lastName: yup
    .string()
    .required("Le nom est requis")
    .min(2, "Le nom doit contenir au moins 2 caractères")
    .max(50, "Le nom ne peut pas dépasser 50 caractères"),

  email: yup
    .string()
    .required("L'email est requis")
    .email("Format d'email invalide")
    .max(100, "L'email ne peut pas dépasser 100 caractères"),

  password: yup
    .string()
    .required("Le mot de passe est requis")
    .min(8, "Le mot de passe doit contenir au moins 8 caractères")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      "Le mot de passe doit contenir au moins une minuscule, une majuscule et un chiffre",
    ),
});

// Schema for admin update
export const adminUpdateSchema = yup.object({
  firstName: yup
    .string()
    .required("Le prénom est requis")
    .min(2, "Le prénom doit contenir au moins 2 caractères")
    .max(50, "Le prénom ne peut pas dépasser 50 caractères"),

  lastName: yup
    .string()
    .required("Le nom est requis")
    .min(2, "Le nom doit contenir au moins 2 caractères")
    .max(50, "Le nom ne peut pas dépasser 50 caractères"),

  email: yup
    .string()
    .required("L'email est requis")
    .email("Format d'email invalide")
    .max(100, "L'email ne peut pas dépasser 100 caractères"),
});

export const forgotPasswordSchema = yup.object({
  email: yup
    .string()
    .required("L'email est requis")
    .email("Format d'email invalide")
    .max(100, "L'email ne peut pas dépasser 100 caractères"),
});

export const newPasswordSchema = yup.object({
  newPassword: yup
    .string()
    .required("Le nouveau mot de passe est requis")
    .min(8, "Le nouveau mot de passe doit contenir au moins 8 caractères")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      "Le nouveau mot de passe doit contenir au moins une minuscule, une majuscule et un chiffre",
    ),
  confirmPassword: yup
    .string()
    .required("La confirmation du mot de passe est requise")
    .oneOf([yup.ref("newPassword")], "Les mots de passe ne correspondent pas"),
});

export type AdminPasswordResetFormData = yup.InferType<
  typeof adminPasswordResetSchema
>;
export type AdminForgotPasswordFormData = yup.InferType<
  typeof forgotPasswordSchema
>;
export type AdminNewPasswordFormData = yup.InferType<typeof newPasswordSchema>;
export type AdminCreateFormData = yup.InferType<typeof adminCreateSchema>;
export type AdminUpdateFormData = yup.InferType<typeof adminUpdateSchema>;
